import {
  Box,
  Menu,
  Divider,
  FormControl,
  Grid,
  Link,
  MenuItem,
  Typography,
  Button,
  Modal,
  TextareaAutosize,
  Select,
  InputLabel,
  Checkbox,
  ListItemText,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Link as MuiLink,
} from "@mui/material";
import React, { useRef } from "react";
import CustomButton from "../../../components/custom-button/customButton";
import { useState } from "react";
import CustomButtoncolor from "../../../components/custom-button/customColorButton";
import { useDispatch, useSelector } from "react-redux";
import PhoneIcon from '@mui/icons-material/Phone';
import CadenceLine from '../churn-recovery/components/CadenceLine';
import { getCustomerInsights } from '../../../store/crm/churn';
import EmailIcon from '@mui/icons-material/Email';
import WalletIcon from '@mui/icons-material/Wallet';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import moment from 'moment';
import { useEffect } from "react";
import {
  getAllCRMCustomer,
  getAllCRMSubscription,
  updateCrmFilters,
} from "../../../store/crm/crm";

import Vector from "../../../assets/images/Vector.png";
import FilterInput from "../../../components/form/filterInput";
import { vectorWrapper } from "../pos/posStyles";
import BackendSearchField from "../../../components/pagination/backendSearch";
import BackendPagination from "../../../components/pagination/backendPagination";
import SetEmailModal from "../../../components/modal/SetEmailModal";
import MakeMemberModal from "./crmMembership/MakeMemberModal";
import SetWalletModal from "../../../components/modal/SetWallet";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import ribbon from "../../../assets/images/ribbon.svg";
import redRibbon from "../../../assets/images/red-badg.svg";
import ribbonorange from "../../../assets/images/ribbon-orange.svg";
import { ribbonwrapper } from "../../../components/card-appointment/CardAppointment";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TreatmentFormButton from "../../../components/card-appointment/treatmentForm";
import BuyWallet from "../../../components/modal/BuyWallet";
import { getSubscriptionCancle } from "../../../store/user/chart-form";
import { MySwal } from "../../../services/utills";
import { mySwalButton } from "../../../components/card-appointment/CardAppointment";
import Waveloading from "../../loading/Waveloading";
import AddUserCard from "../../user/user-wallet/addUserCard";
import { getUserDetails } from "../../../store/auth";
import MangeCardModal from "./crmMembership/MangeCard";
import WarningModal from "../../../components/modal/WarningModal";
import ChatModal from "../churn-recovery/components/chat/ChatModal";
import CustomerNotesDrawer from "./CustomerNotesDrawer";
import TreatmentTab from "../../../components/modal/TreatmentTab";
import AddIcon from '@mui/icons-material/Add';
export const headerwraper = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: { xs: "stretch", lg: "center" },
  flexDirection: { xs: "column", lg: "row" },
  flexWrap: "nowrap",
  gap: { xs: '10px', sm: '12px' },
  width: '100%',
  mb: { xs: '14px', sm: '16px' },
};
export const contentwrap = {
  display: "flex",
  alignItems: "center",
  gap: { xs: '8px', sm: '10px' },
  flexWrap: { xs: 'wrap', lg: 'nowrap' },
  flex: { xs: '1 1 100%', lg: '0 1 auto' },
  minWidth: 0,
  width: { xs: '100%', lg: 'auto' },
};
export const btnwrap = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: { xs: '8px', sm: '10px' },
  flexWrap: { xs: 'wrap', lg: 'nowrap' },
  width: { xs: '100%', lg: 'auto' },
  flex: { xs: '1 1 100%', lg: '1 1 auto' },
  minWidth: 0,
  mb: 0,
};
export const contentwrape = {
  // width:'20%',
  "@media (max-width:480px)": {
    width: "100%",
    alignItems: "center",
  },
};

export const outercontainer = {
  margin: "10px 0",
  borderRadius: "10px",
  display: "flex",
  marginTop: "-10px",
  justifyContent: "space-between",
  "@media (max-width: 1024px)": {
    display: "flex",
    flexDirection: "row",
    // flexWrap:'wrap' ,
  },

  "@media (max-width: 786px)": {
    display: "flex",
    // flexDirection:"column",
    flexWrap: "wrap",
    marginTop: "-15px",
    
  },
};
export const wrapper = {
  marginTop: "1%",

  display: "flex",
};
export const subheading = {
  fontsize: "16px",
  fontWeight: "400",
  fontFamily: "helvetica-lt-std-light",
  color: "#4F4F4F",
};
export const heading = {
  fontsize: "16px",
  color: "#4F4F4F",
  fontFamily: "helvetica-lt-std-roman",
  "@media (max-width: 420px)": {
     fontSize:'14px',
  },
};
export const content = {
  fontsize: "17px",
  fontWeight: "400",
  fontFamily: "helvetica-lt-std-roman",
  color: "#000iul000",
  "@media (max-width: 420px)": {
    fontSize:'14px',
 },
};
export const contentstatus = {
  fontSize: "16px!important",
  fontWeight: "400",
  fontFamily: "helvetica-lt-std-roman",
  color: "#000000",
  "@media (max-width: 420px)": {
    fontSize: "13px !important",
  },
};
export const wallet = {
  display: "flex",
  marginTop: "10px",
  gap: "6px",

  "@media (max-width: 900px)": {
    marginTop: "5%",
  },
  "@media (max-width: 600px)": {
    marginTop: "10px",
  },
};
export const walletwrapper = {

  width: "22%",
  "@media (max-width: 1024px)": {
    width: "50%",
  },
  "@media (max-width: 600px)": {
    dispaly:'flex',
    flexDirection:'column',
  },
};
export const statuswrapper = {   
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "start",
  mt: 4,
  gap: "6px",
  "@media (max-width: 1024px)": {
    width: "50%",
    // gap:'20px',
  },
  "@media (max-width: 786px)": {
    display: "flex",

    flexWrap: "wrap",
  },
  "@media (max-width:600px)": {
    width: "100%",
    alignItems: "center",
    margin: "20px 0px",
    fontSize: "13px",
  },
};
export const Status = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  "@media (max-width: 420px)": {
    fontSize: "13px !important",
  },
};
export const btnwrapper = {
  gap: "2px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "@media (max-width: 1024px)": {
    width: "50%",
  },
  "@media (max-width:480px)": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
  },
};

export const statusinnerwrapper = {
  display: "flex",
  gap: "10px",
  justifyContent: "center",
  "@media (max-width: 420px)": {
    display: "flex",
    //    flexDirection:"column",
    justifyContent: "center",
  },
};
export const linedesign = {
  borderColor: "#9A9797",
  width: "2px",
  "@media (max-width: 600px)": {
    display: "none",
  },  
};
export const wrapperdesign = {
  borderColor: "#9A9797",
  width: "2px",
  height: "67%",
};
export const topheading = {
  fontsize: "25px",
  color: "#333333",   
  fontWeight: "700px",
  fontFamily: "helvetica-lt-std-bold",
};

export const btndesign = {
  width: "max-content",
  borderRadius: "6px!important",
  fontSize: "17px", 
  "@media (max-width: 470px)": {
    width: "100%",
  },
};

export const crmButton = {
  padding: "7px 15px",
  fontSize: "18px",
  borderRadius: "6px",
  width: "100%",
  minWidth: "max-content",
  "@media (max-width: 480px)": {
    width: "fit-content",
    fontSize: "14px",
    padding: "5px",
  },
};
export const crmButtonbook = {
  padding: "10px 15px",
  fontSize: "14px",
  borderRadius: "6px",
  width: "100%",
  minWidth: "max-content",
  "@media (max-width: 480px)": {
    width: "fit-content",
    fontSize: "14px",
    padding: "5px",
  },
};

export const outercontainermain = {
  backgroundColor: "#FFFFFF",
  boxShadow: "0 4px 24px rgba(167,44,104,0.06)",
  border: "1px solid #F0CDDB",
  borderRadius: "12px",
  margin: "15px 0",
  padding: "24px 34px",
  "@media (max-width: 420px)": {
    padding: "20px 16px",
  },
  "@media (max-width: 319px)": {
    padding: "20px 10px",
  },
};

const ACCENT = '#A72C68';
const ACCENT_DARK = '#7B1C4A';
const ACCENT_LIGHT = '#FAEFF5';
const ACCENT_PILL = '#FCE8EC';

const crmCard = {
  background: '#fff',
  borderRadius: '14px',
  boxShadow: '0 1px 3px rgba(16,24,40,0.06), 0 1px 2px rgba(16,24,40,0.04)',
  border: '1px solid #F0F1F4',
  overflow: 'hidden',
  mb: { xs: '12px', sm: '14px' },
};

const crmBanner = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  background: ACCENT_LIGHT,
  px: { sm: '20px', xs: '14px' },
  py: '7px',
};

const bannerMutedLabel = {
  fontSize: '13px',
  color: '#6B7280',
  fontFamily: 'helvetica-lt-std-roman',
};

const bannerStrongValue = {
  fontSize: '14px',
  color: '#1a1a2e',
  fontFamily: 'helvetica-lt-std-bold',
};

const sectionLabel = {
  fontSize: '11px',
  letterSpacing: '1.2px',
  color: '#6B7280',
  fontFamily: 'helvetica-lt-std-bold',
  textTransform: 'uppercase',
  mb: '8px',
};

const statBox = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: ACCENT_LIGHT,
  borderRadius: '10px',
  px: '14px',
  py: '12px',
};

const amountBox = {
  background: ACCENT_LIGHT,
  borderRadius: '12px',
  p: '16px 18px',
};

const buttonRow = {
  // Mobile: uniform 2-column grid so the actions line up neatly.
  // Tablet/desktop: natural flex-wrap row.
  display: { xs: 'grid', sm: 'flex' },
  gridTemplateColumns: { xs: 'repeat(2, 1fr)' },
  flexWrap: { sm: 'wrap' },
  gap: { xs: '8px', sm: '8px' },
  alignItems: 'center',
};

const outlinedActionBtn = (color) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '8px',
  // Fill the grid cell on mobile (aligned); size to content on larger screens.
  width: { xs: '100%', sm: 'auto' },
  minWidth: { xs: 0, sm: 'max-content' },
  background: '#fff',
  color,
  border: `1px solid ${color}`,
  borderRadius: '10px',
  px: { xs: '10px', sm: '14px' },
  py: 0,
  height: { xs: '36px', sm: '36px' },
  fontSize: { xs: '12px', sm: '13px' },
  fontFamily: 'helvetica-lt-std-bold',
  textTransform: 'none',
  cursor: 'pointer',
  transition: 'all 0.18s ease',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  '& .MuiSvgIcon-root': {
    color,
  },
  '&:hover': {
    background: color,
    borderColor: color,
    color: '#fff',
    transform: 'translateY(-1px)',
    boxShadow: `0 4px 10px ${color}33`,
    '& .MuiSvgIcon-root': { color: '#fff' },
  },
  '&:active': {
    transform: 'translateY(0)',
  },
});

// Filled gradient button with a repeating shimmer sweep — the one action on
// the card that should draw the eye (AI Insights).
const aiInsightsBtn = {
  position: 'relative',
  overflow: 'hidden',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '8px',
  width: { xs: '100%', sm: 'auto' },
  minWidth: { xs: 0, sm: 'max-content' },
  background: `linear-gradient(135deg, ${ACCENT_DARK} 0%, ${ACCENT} 45%, #D946EF 100%)`,
  color: '#fff',
  border: '1px solid transparent',
  borderRadius: '10px',
  px: { xs: '10px', sm: '14px' },
  py: 0,
  height: { xs: '36px', sm: '36px' },
  fontSize: { xs: '12px', sm: '13px' },
  fontFamily: 'helvetica-lt-std-bold',
  textTransform: 'none',
  cursor: 'pointer',
  transition: 'all 0.18s ease',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  '& .MuiSvgIcon-root': { color: '#fff' },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-80%',
    width: '50%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.45), transparent)',
    transform: 'skewX(-20deg)',
    animation: 'aiShimmer 2.6s ease-in-out infinite',
  },
  '@keyframes aiShimmer': {
    '0%': { left: '-80%' },
    '55%': { left: '130%' },
    '100%': { left: '130%' },
  },
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: `0 4px 12px ${ACCENT}66`,
  },
  '&:active': {
    transform: 'translateY(0)',
  },
};

// Wrapper that gives the same soft-filled look to modal-trigger components
// (BuyWallet, SetWalletModal, etc.) without modifying them. The inner button is
// positioned to fill the wrapper and made invisible — the icon+label sits on
// top with pointer-events:none so clicks pass through.
const modalBtnWrap = (color) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '8px',
  minWidth: 'max-content',
  height: { xs: '34px', sm: '36px' },
  background: '#fff',
  color,
  border: `1px solid ${color}`,
  borderRadius: '10px',
  px: { xs: '10px', sm: '14px' },
  fontSize: { xs: '12px', sm: '13px' },
  fontFamily: 'helvetica-lt-std-bold',
  textTransform: 'none',
  cursor: 'pointer',
  transition: 'all 0.18s ease',
  lineHeight: 1.2,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  '&:hover': {
    background: color,
    borderColor: color,
    transform: 'translateY(-1px)',
    boxShadow: `0 4px 10px ${color}33`,
    '& .mbw-label': { color: '#fff' },
    '& .mbw-label .MuiSvgIcon-root': { color: '#fff' },
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '& .mbw-label': {
    pointerEvents: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '8px',
    position: 'relative',
    zIndex: 2,
    color,
  },
  '& .mbw-label .MuiSvgIcon-root': {
    color,
  },
  '& button, & .MuiButton-root, & a.MuiButtonBase-root': {
    position: 'absolute !important',
    inset: '0 !important',
    width: '100% !important',
    height: '100% !important',
    opacity: '0 !important',
    background: 'transparent !important',
    backgroundImage: 'none !important',
    boxShadow: 'none !important',
    border: 'none !important',
    padding: '0 !important',
    margin: '0 !important',
    minWidth: '0 !important',
    minHeight: '0 !important',
    cursor: 'pointer',
    zIndex: 1,
    '&:hover': { background: 'transparent !important' },
  },
});

const verticalDivider = {
  width: '1px',
  background: '#F0F1F4',
  alignSelf: 'stretch',
  display: { xs: 'none', lg: 'block' },
};

const bookingStatRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: ACCENT_LIGHT,
  borderRadius: '8px',
  px: '12px',
  py: '8px',
  mb: '8px',
};

const pillSelectSx = {
  background: '#fff',
  height: '44px',
  borderRadius: '10px',
  fontFamily: 'helvetica-lt-std-roman',
  fontSize: '14px',
  color: '#1a1a2e',
  boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
  '& .MuiSvgIcon-root': { color: '#6B7280' },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E5E7EB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #D1D5DB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1.5px solid ${ACCENT}`,
  },
};

const clearFilterPillBtn = {
  height: '44px',
  px: { xs: '14px', sm: '18px' },
  borderRadius: '10px',
  border: '1px solid #F0CDDB',
  background: '#FFF6FA',
  color: ACCENT,
  textTransform: 'capitalize',
  fontWeight: 600,
  fontFamily: 'helvetica-lt-std-bold',
  fontSize: { sm: '14px', xs: '13px' },
  boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
  whiteSpace: 'nowrap',
  transition: 'all 0.18s ease',
  '&:hover': {
    background: '#FBE6EE',
    borderColor: ACCENT,
    color: ACCENT_DARK,
    boxShadow: `0 4px 10px ${ACCENT}22`,
  },
};

export const selectStyle = {
  background: "#fff",
  borderRadius: "4px",
  marginTop: "7px",
  marginRight: "5px",
  marginLeft: "5px",
  height: "44px",
  ".MuiOutlinedInput-notchedOutline": {
    borderWidth: "0!important",
  },
  ".MuiSelect-select": {
    borderColor: " #fff",

    minHeight: "unset",
    "&:focus": {
      borderColor: "#fff",
      outline: "none",
      input: {
        height: "11px",
      },
    },
    "&:hover": {
      borderColor: "#fff",
      outline: "none",
    },
  },
};
const crmFilters = [
  { name: "All", value: "All" },
  { name: "Newest/Latest", value: "Latest" },
  { name: "Oldest", value: "Oldest" },
  { name: "Ascending (A-Z)", value: "Ascending" },
  { name: "Descending (Z-A)", value: "Descending" },
  { name: "Most Recent Booking", value: "MostRecentBooking" },  
  { name: "Least Recent Booking", value: "LeastRecentBooking" },
  { name: "Wallet Highest", value: "WalletHighest" },
  { name: "Wallet Lowest", value: "WalletLowest" },
];


const CustomerBookingFilters = [
  { name: "All Customer", value: "AllCustomer" },
  { name: "Active Members", value: "ActiveMembers" },
  { name: "Decline Members", value: "DeclineMembers" },
  { name: "Cancel Members", value: "CancelMembers" },
 
];
  
const CRMPage = () => {
  const [loading, setLoading] = useState(false); 
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();  
  const {state} = useLocation()
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedBookingType, setSelectedBookingType] = useState("");
  // const location = useLocation()
  // const [selectedBookingType, setSelectedBookingType] = useState("");      
  const authStore = useSelector((state) => state?.authStore);
  const crmStore = useSelector((state) => state?.crmStore);
  const { user } = authStore;
  const provider = user?.defaultProvider;
  const {
    allCrmCustomer = {},
    order_by,
    pageLimit,
    currentPage,
    search,
    customer_type
  } = crmStore;
  const [activeProviderPayment, setActiveProviderPayment] = useState(null);
  const [providerPayment, setProviderPayment] = useState(null);
  const [smsCustomer, setSmsCustomer] = useState(null);
  const [notesCustomer, setNotesCustomer] = useState(null);
  // Cadence comes from the churn insights endpoint (the CRM list API doesn't
  // carry cadence fields); fetched once per customer and cached in the store.
  const churnInsights = useSelector((state) => state?.churnStore?.insights) || {};
  const requestedInsightsRef = useRef(new Set());
  useEffect(() => {
    (allCrmCustomer?.data || []).forEach((c) => {
      const id = c?.customer_id;
      if (!id || churnInsights[id] || requestedInsightsRef.current.has(id)) return;
      requestedInsightsRef.current.add(id);
      dispatch(getCustomerInsights(id));
    });
  }, [allCrmCustomer?.data, churnInsights, dispatch]);
  const searchPerformedRef = useRef(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
   
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  // Function to handle booking type change for multiple selections
  const handleBookingTypeChange = async (event) => {
    // 'event.target.value' will be an array for multiple select   
    setSelectedBookingType(event.target.value);
    await dispatch(updateCrmFilters({ customer_type: selectedBookingType, currentPage: 1 }));
    handleClose();
    await fetchCrmCustomer(); 
  };
  if (!location.state) {
    console.log('No state passed in location');
} else {
    console.log('Received state:', location.state.value);
}

  useEffect(() => {    
    (async () => { 
      if (!user?.id) {  
        await dispatch(getUserDetails());
      }    
      if (user?.id && user?.defaultProvider) {
        let defaultProvider = user?.defaultProvider;
  
        let res =
          defaultProvider?.provider_payment?.length > 0 && 
          defaultProvider?.provider_payment.filter(
            (item) => item?.payment_gateway === "Square" && item?.status === 1
          );
        if (res?.length) {
          setActiveProviderPayment(res[0]);
        }    
        setProviderPayment(defaultProvider?.provider_payment || []);
      }
    })();
  }, [user]);   
  // api integration
  // useEffect(() => {
  //   (async () => {
  //     await fetchCrmCustomer();
  //     dispatch(getAllCRMSubscription());
  //   })();
  // }, []);
  const handleSearch = async (val) => {
    await dispatch(updateCrmFilters({ search: val }));
  };

  const fetchCrmCustomer = async () => {
    setLoading(true);
    await dispatch(getAllCRMCustomer());
    setLoading(false)

  };
  const locationStateValue = state?.value;




  useEffect(() => {
    (async () => {
        if(locationStateValue)
       console.log(" this one call")

       const params = {

        search:locationStateValue,
                currentPage:1
              };
         await dispatch(updateCrmFilters(params))
         fetchCrmCustomer();
    })()
}, [state])
console.log("location get search",locationStateValue)
  const handleFilter = async (value) => {
    await dispatch(updateCrmFilters({ order_by: value, currentPage: 1 }));
    handleClose();
    await fetchCrmCustomer();  
  };   
  
  const handlecustomerfilter = async (value) => {
    await dispatch(updateCrmFilters({  customer_type: value, currentPage: 1 }));
    handleClose();
    await fetchCrmCustomer(); 
  };                                                                          
  const scrollRef = useRef(null); // Create the ref

      const executeScroll = () => {
        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 500); // Delay of 500ms
    
    }
       
  const handelCancle = async (customer) => {
    console.log("issue fixed",customer)
    if (customer?.is_member_ship_button_allow === 0) {
      toggleWarningModal(); // Show the warning modal if the condition is met  
    } else {   
  
    let reason = ''; // Variable to store the reason for cancellation
  
    let confirm = await MySwal.fire({
      icon: "question",
      title: "Confirmation",
      showConfirmButton: false,
      html: (
        <Box sx={{ mb: 4 }}>
          <Typography>
            Please enter the reason for cancelling the Membership:
          </Typography>
          <TextareaAutosize
            minRows={3}
            style={{ width: '100%', margin: '10px 0' }} 
            placeholder="Enter reason here..."
            onChange={(e) => reason = e.target.value}
          />
          <Box sx={{ mt: 3 }}>
            <Button
              sx={{ ...mySwalButton, background: '#27AE60', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none', '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' } }}
              onClick={() => {
                if (reason.trim() === '') {
                  MySwal.showValidationMessage('Please enter a reason for cancellation.'); // Show popup for entering the reason
                } else {
                  MySwal.clickConfirm();
                }
              }}
            >
              Yes
            </Button>
            <Button sx={{ ...mySwalButton, backgroundColor: '#EB5757', color: '#fff', border: '1px solid #EB5757', boxShadow: 'none', '&:hover': { backgroundColor: '#fff', color: '#EB5757', border: '1px solid #EB5757', boxShadow: 'none' } }} onClick={() => MySwal.close()}>
              No
            </Button>
          </Box>
        </Box>
      ),
      preConfirm: () => reason, // This will be passed to the value below if confirmed
    });
  
    if (confirm?.isConfirmed && confirm.value.trim() !== '')  {
      const payload = { reason: confirm.value }; // Include the reason in the payload
      setLoading(true)
       await dispatch(getSubscriptionCancle(customer?.customer_id , payload));
      setLoading(false)
      handleClose();
      await fetchCrmCustomer();
    } else {
      setRescheduleModal(true);   
    }
 
  }
  };                            
  const toggleWarningModal = () => setShowWarningModal(!showWarningModal);         
 
  const fetchPageData = async (page) => {
    await dispatch(updateCrmFilters({ currentPage: page }));
    await fetchCrmCustomer();
  };
  
  const handleLimitChange = async (val) => {
    await dispatch(updateCrmFilters({ pageLimit: val, currentPage: 1 }));
    await fetchCrmCustomer();
  };
  const reFetchData = async () => {  
    await fetchCrmCustomer();       
  };  
 

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };    
  const handleClose = () => {
    setAnchorEl(null);
  };
  const redirect = (to, state) => {
    navigate(to, state);  
  }; 

  const clearfun = async() => {
    setLoading(true);
    await dispatch(updateCrmFilters({ customer_type: "AllCustomer",order_by:"All", search:""}));
    await fetchCrmCustomer();
    setLoading(false)

  }
  const handleSearchIconClick = async() => {
    console.log("value",selectedBookingType)
    // Trigger your API call here
    await dispatch(updateCrmFilters({ customer_type: selectedBookingType, currentPage: 1 }));
    handleClose(); 
    await fetchCrmCustomer();    
  };
  useEffect(() => { 
  
    console.log("Location state value:", locationStateValue);

    const performSearch = async () => {
      if (locationStateValue) {
        console.log("Triggering search for new value:", locationStateValue);
        await dispatch(updateCrmFilters({ search: locationStateValue }));
        await fetchCrmCustomer();
        dispatch(getAllCRMSubscription());
        searchPerformedRef.current = true; 
      }else{
        await fetchCrmCustomer();
        dispatch(getAllCRMSubscription());

      }
    };
   

    performSearch();
  }, [locationStateValue, dispatch]);           


  return (
    <>
      <Box>
        <Box sx={headerwraper} ref={scrollRef}>
          {loading ? <Waveloading fullSize /> : ""}
          <Box sx={contentwrap}>
            <Box
              sx={{
                '& .MuiFormControl-root': { mr: 0, ml: 0 },
                '& .MuiInputBase-root': {
                  height: '44px',
                  borderRadius: '10px',
                  background: '#fff',
                  boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
                  '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #E5E7EB' },
                  '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #D1D5DB' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: `1.5px solid ${ACCENT}` },
                },
              }}
            >
              <FilterInput limit={pageLimit} setLimit={handleLimitChange} />
            </Box>
            <FormControl sx={{ minWidth: { xs: '140px', sm: '170px' }, flex: { xs: '1 1 140px', sm: '0 0 auto' } }}>
              <Select
                value={customer_type}
                label="Customer Type"
                onChange={(event) => handlecustomerfilter(event.target.value)}
                sx={pillSelectSx}
              >
                {CustomerBookingFilters.map((item, index) => (
                  <MenuItem
                    key={index}
                    value={item.value}
                    sx={{
                      py: "7px",
                      my: "3px",
                      background: item.value === customer_type ? `${ACCENT}!important` : "#fff",
                      color: item.value === customer_type ? "#fff" : "#000",
                      "&:hover": { background: ACCENT, color: "#fff" },
                    }}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: { xs: '140px', sm: '170px' }, flex: { xs: '1 1 140px', sm: '0 0 auto' } }}>
              <Select
                value={order_by}
                label="Sort by"
                onChange={(event) => handleFilter(event.target.value)}
                sx={pillSelectSx}
              >
                {crmFilters.map((item, index) => (
                  <MenuItem
                    key={index}
                    value={item.value}
                    sx={{
                      py: "7px",
                      my: "3px",
                      background: item.value === order_by ? `${ACCENT}!important` : "#fff",
                      color: item.value === order_by ? "#fff" : "#000",
                      "&:hover": { background: ACCENT, color: "#fff" },
                    }}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button onClick={clearfun} variant="outlined" sx={clearFilterPillBtn}>
              Clear Filter
            </Button>
          </Box>
          <Box sx={btnwrap}>
            <Box
              sx={{
                flex: { xs: '1 1 100%', sm: '0 0 auto' },
                order: { xs: 2, sm: 1 },
                '& button': {
                  height: '44px !important',
                  borderRadius: '10px !important',
                  px: { xs: '14px', sm: '22px' },
                  fontFamily: 'helvetica-lt-std-bold',
                  fontSize: { xs: '13px', sm: '14px' },
                  width: { xs: '100%', sm: 'auto' },
                  whiteSpace: 'nowrap',
                  boxShadow: '0 4px 12px #27AE6033',
                  background: '#27AE60 !important',
                  borderColor: '#27AE60 !important',
                  color: '#fff !important',
                  transition: 'all 0.18s ease',
                  '&:hover': {
                    background: '#219653 !important',
                    borderColor: '#219653 !important',
                    color: '#fff !important',
                    boxShadow: '0 6px 16px #27AE6055',
                    transform: 'translateY(-1px)',
                  },
                },
              }}
            >
              <CustomButton
                style={{}}
                mainColor={ACCENT}
                subColor={'#fff'}
                handleClick={() => redirect('/crm/customer-relationship-management/add-customer')}
                startIcon={<AddIcon />}
                val={'Add New Contact'}
                size={'large'}
              />
            </Box>
            <FormControl
              sx={{
                flex: { xs: '1 1 100%', sm: '0 0 auto' },
                order: { xs: 1, sm: 2 },
                width: { sm: '240px' },
                minWidth: { sm: '220px' },
                '& .MuiTextField-root': {
                  width: '100%',
                  background: '#fff !important',
                  border: '1px solid #E5E7EB !important',
                  borderRadius: '10px !important',
                  boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
                  transition: 'border-color 0.18s ease',
                },
                '& .MuiTextField-root:hover': { borderColor: '#D1D5DB !important' },
                '& .MuiTextField-root:focus-within': { borderColor: `${ACCENT} !important` },
                '& .MuiInputBase-root': {
                  height: '44px',
                  borderRadius: '10px',
                  pr: '0 !important',
                  overflow: 'hidden',
                },
                '& .MuiInputBase-input': {
                  fontFamily: 'helvetica-lt-std-roman',
                  fontSize: '14px',
                },
                '& .MuiOutlinedInput-notchedOutline': { border: 'none !important' },
                '& .MuiInputAdornment-root .MuiButton-root': {
                  height: '44px !important',
                  borderRadius: '0 !important',
                  background: '#F9FAFB !important',
                  borderLeft: '1px solid #E5E7EB !important',
                  mr: '0 !important',
                  px: '14px !important',
                  '&:hover': { background: '#F3F4F6 !important' },
                },
              }}
            >
              <BackendSearchField
                search={search}
                handleSearch={handleSearch}
                fetchData={async () => {
                  await dispatch(updateCrmFilters({ currentPage: 1 }));
                  await fetchCrmCustomer();
                }}
              />
            </FormControl>
          </Box>
        </Box>

        {allCrmCustomer?.data?.length > 0 ? (
          allCrmCustomer.data.map((customer, index) => {
            const status = customer?.customer_batch ;
            const isCancel = typeof status === 'string' && status.includes('Expire/Cancel');
            const isDeclined = typeof status === 'string' && status.includes('Declined');
            const isMember = !!status && !isCancel && !isDeclined && status !== 'New User';
            const statusColor = isCancel ? '#EF4444' : isDeclined ? '#F59E0B' : isMember ? '#16A34A' : '#0EA5E9';
            const totalBookings = (Number(customer?.new) || 0) + (Number(customer?.completed) || 0) + (Number(customer?.cancelled) || 0) + (Number(customer?.no_show) || 0);
            const joinedDate = customer?.created_at || customer?.register_date || customer?.member_start_date;
            const insight = churnInsights[customer?.customer_id];
            const cadenceInfo = { ...(insight?.cadence || {}), visit_count: insight?.maturity?.visit_count ?? 0 };
            return (
            <Box key={index} sx={crmCard}>
              {/* Top banner */}
              <Box sx={crmBanner}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  {status && (
                    <Box sx={{
                      display: 'inline-flex', alignItems: 'center', gap: '6px',
                      background: '#fff', border: `1px solid ${statusColor}`,
                      borderRadius: '20px', px: '12px', py: '3px',
                    }}>
                      <FiberManualRecordIcon sx={{ color: statusColor, fontSize: 8 }} />
                      <Typography sx={{ fontSize: '12px', color: statusColor, fontFamily: 'helvetica-lt-std-bold' }}>
                        {status}
                      </Typography>
                    </Box>
                  )}
                  {(isCancel || isDeclined || isMember) && customer?.member_start_date && (
                    <Box sx={{
                      display: 'inline-flex', alignItems: 'center',
                      background: '#fff', border: `1px solid ${statusColor}`,
                      borderRadius: '20px', px: '12px', py: '3px',
                    }}>
                      <Typography sx={{ fontSize: '12px', color: statusColor, fontFamily: 'helvetica-lt-std-roman' }}>
                        Start Date: {customer?.member_start_date}
                        {isDeclined && customer?.updated_date ? `, Decline Date: ${customer?.updated_date}` : ''}
                        {isCancel && customer?.updated_date ? `, Cancelled Date: ${customer?.updated_date}` : ''}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                  {joinedDate && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Typography sx={bannerMutedLabel}>Joined</Typography>
                      <Typography sx={bannerStrongValue}>{moment(joinedDate).format('MMM D, YYYY')}</Typography>
                    </Box>
                  )}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Typography sx={bannerMutedLabel}>Customer</Typography>
                    <Typography sx={{ ...bannerStrongValue, color: ACCENT }}>#{customer?.customer_id}</Typography>
                  </Box>
                </Box>
              </Box>

              {/* Horizontal 3-column main: Customer | Bookings | Amount+Activity */}
              <Grid container sx={{ p: { xs: '12px 14px', sm: '14px 20px' }, alignItems: 'stretch' }} columnSpacing={{ xs: 0, md: 3 }} rowSpacing={1.5}>
                {/* COL 1: Customer */}
                <Grid item xs={12} sm={6} md={4} sx={{ pr: { sm: '12px', md: '12px' } }}>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', mb: '8px' }}>
                    <Typography
                      sx={{ fontSize: '19px', fontFamily: 'helvetica-lt-std-bold', color: '#1a1a2e', textTransform: 'capitalize', lineHeight: 1.2, cursor: 'pointer', display: 'inline-block', '&:hover': { color: ACCENT, textDecoration: 'underline' } }}
                      onClick={() => {
                        if (customer?.customer_id) {
                          redirect(`/crm/customer-relationship-management/customer/profile-info/${customer?.customer_id}`);
                        }
                      }}
                    >
                      {customer?.customer_name}
                    </Typography>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', ml: 'auto', background: ACCENT_PILL, borderRadius: '8px', px: '10px', py: '4px' }}>
                      <WalletIcon sx={{ fontSize: 15, color: ACCENT }} />
                      <Typography sx={{ fontSize: '13px', color: ACCENT, fontFamily: 'helvetica-lt-std-bold' }}>
                        ${customer?.wallet || 0}
                      </Typography>
                    </Box>
                    {/* <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexShrink: 0, background: ACCENT_PILL, borderRadius: '8px', px: '10px', py: '4px' }}>
                      <WalletIcon sx={{ fontSize: 15, color: ACCENT }} />
                      <Typography sx={{ fontSize: '13px', color: ACCENT, fontFamily: 'helvetica-lt-std-bold' }}>
                        ${customer?.wallet || 0}
                      </Typography>
                    </Box> */}
                  </Box>
                  {customer?.phone && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mb: '4px' }}>
                      <PhoneIcon sx={{ fontSize: 14, color: '#6B7280' }} />
                      <MuiLink href={`tel:${customer?.phone}`} sx={{ color: '#1a1a2e', textDecoration: 'none', fontSize: '13px', fontFamily: 'helvetica-lt-std-roman', '&:hover': { color: ACCENT } }}>
                        {customer?.phone}
                      </MuiLink>
                    </Box>
                  )}
                  {customer?.email && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <EmailIcon sx={{ fontSize: 14, color: '#6B7280' }} />
                      <MuiLink href={`mailto:${customer?.email}`} sx={{ color: '#1a1a2e', textDecoration: 'none', fontSize: '13px', fontFamily: 'helvetica-lt-std-roman', overflowWrap: 'anywhere', '&:hover': { color: ACCENT } }}>
                        {customer?.email}
                      </MuiLink>
                    </Box>
                  )}
                  <Box sx={{ mt: '10px' }}>
                    <Typography sx={sectionLabel}>Rebooking Cadence</Typography>
                    <CadenceLine customer={cadenceInfo} />
                  </Box>
                </Grid>

                {/* COL 2: Bookings — 2x2 grid */}
                <Grid item xs={12} sm={6} md={4} sx={{ borderLeft: { md: '1px solid #F0F1F4' }, pl: { sm: '12px !important', md: '28px !important' }, pr: { md: '12px' }, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '8px' }}>
                    <Typography sx={{ ...sectionLabel, mb: 0 }}>Bookings</Typography>
                    <Box sx={{ background: ACCENT_PILL, color: ACCENT, borderRadius: '20px', px: '8px', py: '1px' }}>
                      <Typography sx={{ fontSize: '10px', letterSpacing: '0.8px', fontFamily: 'helvetica-lt-std-bold' }}>
                        {totalBookings} {totalBookings === 1 ? 'ITEM' : 'ITEMS'}
                      </Typography>
                    </Box>
                  </Box>
                  <Grid container spacing={1} sx={{ flexGrow: 1 }}>
                    {[
                      { label: 'New', value: customer?.new },
                      { label: 'Completed', value: customer?.completed },
                      { label: 'Cancelled', value: customer?.cancelled },
                      { label: 'No Show', value: customer?.no_show },
                    ].map((stat) => (
                      <Grid item xs={6} key={stat.label}>
                        <Box sx={{ ...bookingStatRow, mb: 0, height: '100%' }}>
                          <Typography sx={{ fontSize: '12px', color: '#374151', fontFamily: 'helvetica-lt-std-roman' }}>
                            {stat.label}
                          </Typography>
                          <Typography sx={{ fontSize: '15px', color: ACCENT, fontFamily: 'helvetica-lt-std-bold' }}>
                            {stat.value || 0}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                {/* COL 3: Amount on top, Activity below */}
                <Grid item xs={12} sm={12} md={4} sx={{ borderLeft: { md: '1px solid #F0F1F4' }, pl: { md: '28px !important' }, display: 'flex', flexDirection: 'column' }}>
                  <Typography sx={sectionLabel}>Amount</Typography>
                  <Box sx={{ ...amountBox, p: '10px 14px', flexGrow: 1 }}>
                    <Typography sx={{ fontSize: '11px', color: ACCENT, letterSpacing: '1.2px', fontFamily: 'helvetica-lt-std-bold' }}>
                      TOTAL REVENUE
                    </Typography>
                    <Typography sx={{ fontSize: '22px', color: ACCENT_DARK, fontFamily: 'helvetica-lt-std-bold', lineHeight: 1.1, mt: '2px' }}>
                      ${customer?.total_revenue || 0}
                    </Typography>
                    <Box sx={{ borderBottom: '1px dashed #E0B4C8', my: '8px' }} />
                    <Typography sx={{ fontSize: '12px', color: '#6B7280', fontFamily: 'helvetica-lt-std-roman' }}>
                      Wallet Used: <span style={{ color: '#1a1a2e', fontFamily: 'helvetica-lt-std-bold' }}>${parseFloat(customer?.wallet_used || 0).toFixed(2)}</span>
                    </Typography>
                    {customer?.outstanding_balance && customer.outstanding_balance > 0 ? (
                      <Typography sx={{ fontSize: '12px', color: '#EF4444', mt: '4px', fontFamily: 'helvetica-lt-std-bold' }}>
                        Outstanding: ${parseFloat(customer?.outstanding_balance).toFixed(2)}
                      </Typography>
                    ) : null}
                  </Box>
                </Grid>
              </Grid>

              {/* Actions — single flex-wrap row, uniform sizing with icons */}
              <Box sx={{ background: '#F7F8FA', borderTop: '1px solid #F0F1F4', px: { sm: '20px', xs: '12px' }, py: '9px' }}>
                <Box sx={buttonRow}>
                  <Box
                    sx={aiInsightsBtn}
                    onClick={() => redirect(`/crm/customer-relationship-management/customer/insights/${customer?.customer_id}`)}
                  >
                    <AutoAwesomeIcon sx={{ fontSize: 15 }} />
                    AI Insights
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#1976D2')}
                    onClick={() => {
                      localStorage.setItem('url', pathname);
                      redirect(`/crm/add-appointment/user/${customer?.customer_id}`);
                    }}
                  >
                    <EventOutlinedIcon sx={{ fontSize: 15 }} />
                    Book Now
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#A533B8')}
                    onClick={() => setNotesCustomer({
                      customer_id: customer?.customer_id,
                      customer_name: customer?.customer_name,
                    })}
                  >
                    <StickyNote2OutlinedIcon sx={{ fontSize: 15 }} />
                    Notes
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#F59E0B')}
                    onClick={() => redirect(`/crm/customer-relationship-management/customer/attachments/${customer?.customer_id}`)}
                  >
                    <AttachFileOutlinedIcon sx={{ fontSize: 15 }} />
                    Attachments
                  </Box>
                  <Box sx={modalBtnWrap('#D946EF')}>
                    <Box className="mbw-label">
                      <MailOutlineIcon sx={{ fontSize: 15 }} />
                      Send Email
                    </Box>
                    <SetEmailModal
                      fontsizee={"13px"}
                      paddingCRM={"6px 12px"}
                      style={{ fontSize: "13px !important" }}
                      customer_id={customer?.customer_id}
                    />
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#0EA5E9')}
                    onClick={() => setSmsCustomer({
                      user_id: customer?.customer_id,
                      name: customer?.customer_name,
                      phone: customer?.phone,
                    })}
                  >
                    <SmsOutlinedIcon sx={{ fontSize: 15 }} />
                    Send SMS
                  </Box>
                  <MuiLink href={`tel:${customer?.phone}`} sx={{ ...outlinedActionBtn('#4B5563'), textDecoration: 'none' }}>
                    <PhoneIcon sx={{ fontSize: 15 }} />
                    Call
                  </MuiLink>
                  <Box sx={modalBtnWrap('#0D9488')}>
                    <Box className="mbw-label">
                      <DescriptionOutlinedIcon sx={{ fontSize: 15 }} />
                      Client Form
                    </Box>
                    <TreatmentFormButton
                      data={customer}
                      crmStyle={{ fontSize: '13px', padding: '6px 12px' }}
                    />
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#A533B8')}
                    onClick={() => redirect(`/crm/customer-relationship-management/customer/gallery/${customer?.customer_id}`)}
                  >
                    <ImageOutlinedIcon sx={{ fontSize: 15 }} />
                    Gallery
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#4B5563')}
                    onClick={() => {
                      if (customer?.customer_id) {
                        redirect(`/crm/customer-relationship-management/customer/history/${customer?.customer_id}`);
                      }
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ fontSize: 15 }} />
                    Booking History
                  </Box>
                  <Box
                    sx={outlinedActionBtn('#F59E0B')}
                    onClick={() => redirect(`/crm/point-of-sale/new-invoice`, { state: { user: customer } })}
                  >
                    <AddIcon sx={{ fontSize: 15 }} />
                    Add Invoice
                  </Box>
                  <Box sx={modalBtnWrap('#16A34A')}>
                    <Box className="mbw-label">
                      <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 15 }} />
                      Buy Wallet
                    </Box>
                    <BuyWallet customer_id={customer?.customer_id} reFetchData={reFetchData} />
                  </Box>
                  <Box sx={modalBtnWrap('#16A34A')}>
                    <Box className="mbw-label">
                      <WalletIcon sx={{ fontSize: 15 }} />
                      Set Wallet
                    </Box>
                    <SetWalletModal
                      styles={{ fontSize: "13px" }}
                      reFetchData={reFetchData}
                      customer_id={customer?.customer_id}
                    />
                  </Box>
                  <Box sx={modalBtnWrap('#EF4444')}>
                    <Box className="mbw-label">
                      <CreditCardIcon sx={{ fontSize: 15 }} />
                      Manage Card
                    </Box>
                    <MangeCardModal
                      styles={{ fontSize: "13px", '@media (max-width:319px)': { fontSize: "12px !important" } }}
                      reFetchData={reFetchData}
                      customer_id={customer?.customer_id}
                      fsize={"13px"}
                    />
                  </Box>
                  <Box sx={modalBtnWrap('#1976D2')}>
                    <Box className="mbw-label">
                      <BookmarkBorderOutlinedIcon sx={{ fontSize: 15 }} />
                      Treatment History
                    </Box>
                    <TreatmentTab customer_id={customer?.customer_id} />
                  </Box>
                  {(user?.is_new === 0 && user?.is_allow_membership !== 0) && (
                    <Box sx={modalBtnWrap('#7C3AED')}>
                      <Box className="mbw-label">
                        <PersonIcon sx={{ fontSize: 15 }} />
                        Membership
                      </Box>
                      <MakeMemberModal
                        styles={{ fontSize: "13px", '@media (max-width:319px)': { fontSize: "12px !important" } }}
                        reFetchData={reFetchData}
                        customer_id={customer?.customer_id}
                        is_member_ship_button_allow={customer?.is_member_ship_button_allow}
                        fsize={"13px"}
                      />
                    </Box>
                  )}
                  {(customer?.is_membered || customer?.is_declined) && (user?.is_new === 0) ? (
                    <Box
                      sx={outlinedActionBtn('#EF4444')}
                      onClick={() => handelCancle(customer)}
                    >
                      <FiberManualRecordIcon sx={{ fontSize: 10 }} />
                      Cancel Membership
                    </Box>
                  ) : null}
                </Box>
                {showWarningModal && <WarningModal />}
              </Box>
            </Box>
            );
          })
        ) : (
          <Box sx={{ width: "100%", mt: "30px" }}>
            <Typography sx={{ textAlign: "center" }}>No customers available</Typography>
          </Box>
        )}
        {allCrmCustomer?.meta?.last_page > 1 && (
          <BackendPagination
            count={allCrmCustomer?.meta?.last_page}
            currentPage={currentPage}
            handleOnChange={fetchPageData}
            executeScroll={executeScroll}
          />
        )}
        <ChatModal
          open={!!smsCustomer}
          onClose={() => setSmsCustomer(null)}
          customer={smsCustomer}
        />
        <CustomerNotesDrawer
          open={!!notesCustomer}
          onClose={() => setNotesCustomer(null)}
          customer={notesCustomer}
        />
      </Box>
    </>
  );
};

export default CRMPage;